import type { SimEvent } from '../core/events';
import {
  peekPort,
  portHasRoom,
  singleInput,
  singleOutput,
  tryPushToPort,
  tryTakeFromPort,
} from '../core/port';
import { traceUpstreamObservable } from '../core/routing';
import { unsubscribeAll } from '../core/subscription';
import { drainOutput } from './shared';
import type { MachineHandler } from './registry';

export const takeHandler: MachineHandler = {
  kind: 'take',
  step({ state, machine }) {
    if (machine.kind !== 'take') return [];
    const events: SimEvent[] = [];
    const observable = traceUpstreamObservable(state, machine.position);

    /** A fresh subscribe (false -> true) restarts the take(n) count, matching RxJS's per-subscription semantics. */
    const observableSubscribed = observable !== undefined && state.subscribed;
    if (observableSubscribed && !machine.internal.observableWasSubscribed) {
      machine.internal.passed = 0;
    }
    machine.internal.observableWasSubscribed = observableSubscribed;

    const inputPort = singleInput(machine.inputs);
    const outputPort = singleOutput(machine.outputs);

    drainOutput(state, machine, events);

    const waitingId = peekPort(inputPort);
    if (
      waitingId !== undefined &&
      machine.config &&
      machine.internal.passed < machine.config.count
    ) {
      if (portHasRoom(outputPort)) {
        tryTakeFromPort(inputPort);
        tryPushToPort(outputPort, waitingId);
        machine.internal.passed += 1;

        if (machine.internal.passed >= machine.config.count && observable && state.subscribed) {
          unsubscribeAll(state);
          events.push({
            type: 'observableUnsubscribed',
            observableId: observable.id,
            packetId: waitingId,
          });
        }
      }
    }

    return events;
  },
};
